import React from "react";
import Navbar from "../components/Navbar.jsx";
import { useAuth } from "../features/auth";
import LearnControls from "../components/LearnControls.jsx";

export default function LearnPage() {
  const { user, signOut } = useAuth();

  return (
    <div style={{ minHeight: "100vh", background: "#f6f6f4" }}>
      <Navbar user={user} signOut={signOut} />
      <div style={{ width: "min(1180px, 92vw)", margin: "0 auto"}}>
        <LearnControls />
      </div>
    </div>
  );
}
